import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "b-user-form" }
const _hoisted_2 = { class: "b-user-form__inner" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "b-user-form__item__text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_WorkerAvatar = _resolveComponent("WorkerAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localList, (user) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["b-user-form__item", { "b-user-form__item--active": _ctx.userFilterId === user.id }]),
          onClick: ($event: any) => (_ctx.$emit("click", user.id))
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({ "backgroundColor": _ctx.userColor(user) }),
            class: _normalizeClass(user.is_site ? `b-room-form__item__avatar` : `b-user-form__item__avatar`)
          }, [
            (!user.avatar_url)
              ? (_openBlock(), _createBlock(_component_FwIcon, {
                  key: 0,
                  class: "b-worker__avatar__icon",
                  icon: user.is_site ? `icon-door` : `no-avatar`,
                  size: "10",
                  color: "#fff"
                }, null, 8, ["icon"]))
              : (_openBlock(), _createBlock(_component_WorkerAvatar, {
                  key: 1,
                  class: "h-mv-15",
                  avatarSize: 22,
                  hideInfo: true,
                  worker: user,
                  size: "small",
                  align: "small"
                }, null, 8, ["worker"]))
          ], 6),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.name(user))), 1)
        ], 10, _hoisted_3))
      }), 256))
    ])
  ]))
}